import { createActionCreator } from 'deox';

import { TChangeLicenseSeatsMaterials, TChangeLicenseSeatsResponse } from '@/services/api/company';

// CONSTANTS

export enum EChangeLicenseSeatsAction {
  CHANGE_LICENSE_SEATS = 'CHANGE_LICENSE_SEATS',
  CHANGE_LICENSE_SEATS_REQUEST = 'CHANGE_LICENSE_SEATS_REQUEST',
  CHANGE_LICENSE_SEATS_SUCCESS = 'CHANGE_LICENSE_SEATS_SUCCESS',
  CHANGE_LICENSE_SEATS_FAILED = 'CHANGE_LICENSE_SEATS_FAILED',
}

// TYPES

export type TChangeLicenseSeatsRequest = {
  type: EChangeLicenseSeatsAction.CHANGE_LICENSE_SEATS_REQUEST;
  payload: {
    materials: TChangeLicenseSeatsMaterials;
    successCallback?: (response: TChangeLicenseSeatsResponse) => void;
    failedCallback?: (err: unknown) => void;
  };
};

export type TChangeLicenseSeatsSuccess = {
  type: EChangeLicenseSeatsAction.CHANGE_LICENSE_SEATS_SUCCESS;
  payload: { response: TChangeLicenseSeatsResponse };
};

export type TChangeLicenseSeatsFailed = { type: EChangeLicenseSeatsAction.CHANGE_LICENSE_SEATS_FAILED };

// FUNCTION

export const changeLicenseSeatsAction = {
  request: createActionCreator(
    EChangeLicenseSeatsAction.CHANGE_LICENSE_SEATS_REQUEST,
    (resolve) =>
      (
        materials: TChangeLicenseSeatsMaterials,
        successCallback?: (response: TChangeLicenseSeatsResponse) => void,
        failedCallback?: (err: unknown) => void,
      ): TChangeLicenseSeatsRequest =>
        resolve({ materials, successCallback, failedCallback }),
  ),
  success: createActionCreator(
    EChangeLicenseSeatsAction.CHANGE_LICENSE_SEATS_SUCCESS,
    (resolve) =>
      (response: TChangeLicenseSeatsResponse): TChangeLicenseSeatsSuccess =>
        resolve({ response }),
  ),
  failure: createActionCreator(
    EChangeLicenseSeatsAction.CHANGE_LICENSE_SEATS_FAILED,
    (resolve) =>
      (error: any): TChangeLicenseSeatsFailed =>
        resolve({ error }),
  ),
};
